import { isAnyModalOpen } from 'dibs-elements/exports/ModalContainer.tsx';
import { type AuthResponseType } from 'dibs-buyer-layout/exports/authTypes.ts';

const MODAL_REGISTRY_EVENT = 'dibs-modal-registry-update';
const RELOAD_DEBOUNCE_MS = 300;
const MAX_WAIT_MS = 10 * 60 * 1000;

let reloadScheduled = false;
let debounceTimer: ReturnType<typeof setTimeout> | null = null;
let maxWaitTimer: ReturnType<typeof setTimeout> | null = null;
let listener: (() => void) | null = null;

function cleanup(): void {
    if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = null;
    }
    if (maxWaitTimer) {
        clearTimeout(maxWaitTimer);
        maxWaitTimer = null;
    }
    if (listener) {
        window.removeEventListener(MODAL_REGISTRY_EVENT, listener);
        listener = null;
    }
    reloadScheduled = false;
}

function isIncompleteEmailOnlyRegistration(authResponse?: AuthResponseType): boolean {
    return !!(authResponse?.accountCreated && !authResponse?.passwordAdded);
}

function attemptReload(): void {
    if (isAnyModalOpen()) {
        return;
    }

    if (debounceTimer) {
        clearTimeout(debounceTimer);
    }

    debounceTimer = setTimeout(() => {
        if (!isAnyModalOpen()) {
            cleanup();
            window.location.reload();
        }
    }, RELOAD_DEBOUNCE_MS);
}

export function scheduleHomepageReloadWhenAuthIdle(authResponse?: AuthResponseType): void {
    if (isIncompleteEmailOnlyRegistration(authResponse)) {
        return;
    }

    if (!reloadScheduled) {
        reloadScheduled = true;
        listener = attemptReload;
        window.addEventListener(MODAL_REGISTRY_EVENT, listener);
        maxWaitTimer = setTimeout(cleanup, MAX_WAIT_MS);
    }

    attemptReload();
}
